module.exports = __webpack_public_path__ + "static/media/44455661_2199900926751753_1743479971663314944_o-thumb.65e58acf.jpg";